if (!customElements.get('scroll-to')) {
  class ScrollTo extends HTMLElement {
    constructor () {
      super();

      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback () {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback () {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick (event) {
      const target = this.getTargetElement() || this.getNextSectionElement();
      if (!target) return;

      event.preventDefault();

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const offset = this.getScrollOffset();
      const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);

      window.scrollTo({
        top,
        behavior,
      });
    }

    getScrollOffset () {
      const offsetVariable = this.dataset.scrollOffsetVariable || '--header-height';
      const offsetValue = getComputedStyle(document.documentElement).getPropertyValue(offsetVariable).trim();
      const offset = Number.parseFloat(offsetValue);

      return Number.isFinite(offset) ? offset : 0;
    }

    getTargetElement () {
      const selector = this.dataset.scrollTargetSelector?.trim();
      if (!selector) return null;

      try {
        return document.querySelector(selector);
      } catch (error) {
        console.warn('[scroll-to] Invalid target selector', error);
        return null;
      }
    }

    getNextSectionElement () {
      const currentSection = this.closest('.shopify-section, [id^="shopify-section-"]') || this.closest('section');
      if (!currentSection) return null;

      let nextSection = currentSection.nextElementSibling;
      while (nextSection) {
        if (this.isVisibleElement(nextSection)) return nextSection;
        nextSection = nextSection.nextElementSibling;
      }

      return null;
    }

    isVisibleElement (element) {
      if (!(element instanceof HTMLElement)) return false;

      return element.getClientRects().length > 0 && getComputedStyle(element).display !== 'none';
    }
  }

  customElements.define('scroll-to', ScrollTo);
}
